import { useEffect, useState } from "react";

const quotes = [
  "People are not your most important asset. The right people are. – Jim Collins",
  "Train people well enough so they can leave. Treat them well enough so they don’t want to. – Richard Branson",
  "To win in the marketplace, you must first win in the workplace. – Doug Conant",
  "The way your employees feel is the way your customers will feel. – Sybil F. Stershic",
  "Employees engage with employers and brands when they’re treated as humans. – Meghan Biro"
];

const LoadingLoader = () => {
  const [quote, setQuote] = useState("");

  useEffect(() => {
    const randomQuote = quotes[Math.floor(Math.random() * quotes.length)];
    setQuote(randomQuote);
  }, []);

  return (
    <div className="fixed inset-0 z-50 bg-white dark:bg-gray-900 dark:bg-opacity-0 bg-opacity-90 flex items-center justify-center">
      <div className="text-center">
        <div className="loader border-t-4 border-blue-500 rounded-full w-12 h-12 animate-spin mb-4 mx-auto" />
        <p className="text-gray-700 text-lg font-medium mb-2 dark:text-white">Loading</p>
        <p className="text-sm text-gray-500 max-w-md mx-auto italic">"{quote}"</p>
      </div>
    </div>
  );
};

export default LoadingLoader;
